const escolas_que_nao_permitem_transferencia = {
  path: "/escolas-nao-permitem-transferencia",
  redirect: "/escolas-nao-permitem-transferencia",
  meta: {
    breadCrumb:
      "Gerenciamento de Matrícula - Apoio Gerencial de Planejamento da Matrícula",
  },
  children: [
    {
      path: "/escolas-nao-permitem-transferencia",
      name: "escolas_nao_permitem_transferencia",
      meta: {
        allowedPermissions: ["veto_transferencia_listagem"],
      },
      component: () =>
        import(
          "@/views/EscolasQueNaoPermitemTransferencia/EscolasQueNaoPermitemTransferencia.vue"
        ),
    },
  ],
};

export { escolas_que_nao_permitem_transferencia };
